window.Select = function () {
    var el = this;
    var isCanRemoveSelection = true;
    var rotateEL = false;
    var $rotateBalloon = $('#rotate-balloon');
    var panelsPositions = {width: 180, height: 30};
    var panelCellPosition = {width: 30, height: 30};
    var defaultRotatePositions = {width: 30, height: 30};
    var rotatePositions = {};
    var defaultRemovePositions = {width: 30, height: 30};
    var removePositions = {};
    var defaultLayerUpPositions = {width: 30, height: 30};
    var layerUpPositions = {};
    var defaultLayerDownPositions = {width: 30, height: 30};
    var layerDownPositions = {};
    var defaultMoveImagePositions = {x: 0, y: 0, width: 64, height: 64};
    var moveImagePositions = {};
    var defaultCopyPositions = {width: 30, height: 30};
    var copyPositions = {};
    var circlePositions = {};
    var centerPositions = {};
    var positions = {};
    
    function initRotateBalloon() {
        var offset = {top: 0, left: 0};
        var element = document.getElementById('workarea');
        if (element === null) {
            return;
        }

        var pos = element.getBoundingClientRect();
        var fixOffset = 70;

        offset.top += pos.top + $(window).scrollTop() - fixOffset;
        offset.left = pos.left + pos.width / 2 - $rotateBalloon.outerWidth() / 2;
        
        $rotateBalloon
                .removeClass('hide')
                .offset(offset)
                .text(parseInt(el.transform.getRotate(rotateEL).angle));
    }
    
    function hideRotateBalloon() {
        $rotateBalloon.addClass('hide');
    }

    function calculatePosSelection(element) {
        var pos = element.getBBox();
        var matrix = element.getCTM();
        var fixTextPosition = {y: 25};
        var countPoints = 9; // required number of points
        var points = [];
        var i;

        for (i = 0; i < countPoints; i++) {
            points[i] = el.svgRoot.createSVGPoint();
        }

        points[0].x = pos.x;
        points[0].y = pos.y;
        points[1].x = pos.x + pos.width;
        points[1].y = pos.y;
        points[2].x = pos.x + pos.width;
        points[2].y = pos.y + pos.height;
        points[3].x = pos.x;
        points[3].y = pos.y + pos.height;
        points[4].x = pos.x;
        points[4].y = pos.y + pos.height / 2;
        points[5].x = pos.x + pos.width;
        points[5].y = pos.y + pos.height / 2;
        points[6].x = pos.x + pos.width / 2;
        points[6].y = pos.y;
        points[7].x = pos.x + pos.width / 2;
        points[7].y = pos.y + pos.height;
        points[8].x = pos.x + pos.width / 2;
        points[8].y = pos.y + pos.height / 2;

        if (el._parent.selectType === 'text') {
            points[6].y -= fixTextPosition.y;
            points[7].y += fixTextPosition.y;
        }


        for (i = 0; i < countPoints; i++) {
            points[i] = points[i].matrixTransform(matrix);
        }

        positions = {
            x1: points[0].x,
            y1: points[0].y,
            x2: points[1].x,
            y2: points[1].y,
            x3: points[2].x,
            y3: points[2].y,
            x4: points[3].x,
            y4: points[3].y
        };

        circlePositions = {
            x1: points[0].x,
            y1: points[0].y,
            x2: points[1].x,
            y2: points[1].y,
            x3: points[2].x,
            y3: points[2].y,
            x4: points[3].x,
            y4: points[3].y,
            x5: points[4].x,
            y5: points[4].y,
            x7: points[5].x,
            y7: points[5].y,
            radius: 5 / el.workarea.workAreaScale
        };

        rotatePositions.width = defaultRotatePositions.width / el.workarea.workAreaScale;
        rotatePositions.height = defaultRotatePositions.height / el.workarea.workAreaScale;
        rotatePositions.x = points[6].x - parseInt(rotatePositions.width / 2);
        rotatePositions.y = points[6].y - parseInt(rotatePositions.height / 2);
        
        removePositions.width = defaultRemovePositions.width / el.workarea.workAreaScale;
        removePositions.height = defaultRemovePositions.height / el.workarea.workAreaScale;
        removePositions.x = points[7].x - parseInt(removePositions.width / 2);
        removePositions.y = points[7].y - parseInt(removePositions.height / 2);
        
        layerUpPositions.width = defaultLayerUpPositions.width / el.workarea.workAreaScale;
        layerUpPositions.height = defaultLayerUpPositions.height / el.workarea.workAreaScale;
        layerUpPositions.x = points[7].x - parseInt(layerUpPositions.width / 2) + 30 / el.workarea.workAreaScale;
        layerUpPositions.y = points[7].y - parseInt(layerUpPositions.height / 2);
        
        layerDownPositions.width = defaultLayerDownPositions.width / el.workarea.workAreaScale;
        layerDownPositions.height = defaultLayerDownPositions.height / el.workarea.workAreaScale;
        layerDownPositions.x = points[7].x - parseInt(layerDownPositions.width / 2) - 30 / el.workarea.workAreaScale;
        layerDownPositions.y = points[7].y - parseInt(layerDownPositions.height / 2);
        
        copyPositions.width = defaultCopyPositions.width / el.workarea.workAreaScale;
        copyPositions.height = defaultCopyPositions.height / el.workarea.workAreaScale;
        copyPositions.x = points[7].x - parseInt(copyPositions.width / 2) + 30 / el.workarea.workAreaScale;
        copyPositions.y = points[7].y - parseInt(copyPositions.height / 2);

        moveImagePositions.width = defaultMoveImagePositions.width / el.workarea.workAreaScale;
        moveImagePositions.height = defaultMoveImagePositions.height / el.workarea.workAreaScale;
        moveImagePositions.x = points[8].x - parseInt(moveImagePositions.width / 2);
        moveImagePositions.y = points[8].y - parseInt(moveImagePositions.height / 2);

        panelsPositions.width = 180;
        panelsPositions.x = pos.x + parseInt((pos.width - panelsPositions.width) / 2);
        panelsPositions.y = pos.y + pos.height + panelsPositions.height;
        
        panelCellPosition.x = pos.x + parseInt((pos.width - panelCellPosition.width) / 2);
        panelCellPosition.y = pos.y + pos.height + panelCellPosition.height;
        
        centerPositions.x = pos.x + parseInt(pos.width / 2);
        centerPositions.y = pos.y + parseInt(pos.height / 2);
        
        if (el.selectType === 'backgrounds') {
            panelsPositions.width = 150;
        }
    }

    el.update = function (element) {
        calculatePosSelection(element);

        $("#workarea").attr('points', positions.x1 + ',' + positions.y1 + ' ' + positions.x2 + ',' + positions.y2 + ' ' + positions.x3 + ',' + positions.y3 + ' ' + positions.x4 + ',' + positions.y4 + ' ' + positions.x1 + ',' + positions.y1);

        if (el._parent.selectType !== 'text') {
            $("#workarea-border-1").attr('x1', positions.x1).attr('y1', positions.y1).attr('x2', positions.x2).attr('y2', positions.y2);
            $("#workarea-border-2").attr('x1', positions.x2).attr('y1', positions.y2).attr('x2', positions.x3).attr('y2', positions.y3);
            $("#workarea-border-3").attr('x1', positions.x3).attr('y1', positions.y3).attr('x2', positions.x4).attr('y2', positions.y4);
            $("#workarea-border-4").attr('x1', positions.x4).attr('y1', positions.y4).attr('x2', positions.x1).attr('y2', positions.y1);
            $("#circle-1").attr('cx', circlePositions.x1).attr('cy', circlePositions.y1);
            $("#circle-2").attr('cx', circlePositions.x2).attr('cy', circlePositions.y2);
            $("#circle-3").attr('cx', circlePositions.x3).attr('cy', circlePositions.y3);
            $("#circle-4").attr('cx', circlePositions.x4).attr('cy', circlePositions.y4);
            $("#circle-5").attr('cx', circlePositions.x5).attr('cy', circlePositions.y5);
            $("#circle-7").attr('cx', circlePositions.x7).attr('cy', circlePositions.y7);
        }

        if (el.selectType === 'cell' || el.selectType === 'text' || el.selectType === 'decors') {
            $("#rotate-btn").attr('x', rotatePositions.x).attr('y', rotatePositions.y);
            $("#delete-btn").attr('x', removePositions.x).attr('y', removePositions.y);
            $("#copy-btn").attr('x', copyPositions.x).attr('y', copyPositions.y);
            initRotateBalloon();
        }
        
        if (el.selectType === 'cell' || el.selectType === 'decors') {
            $("#layer-up-btn").attr('x', layerUpPositions.x).attr('y', layerUpPositions.y);
            $("#layer-down-btn").attr('x', layerDownPositions.x).attr('y', layerDownPositions.y);
        }

        if (el._parent.selectType === 'cell' && el.workData.workareas[el.selectWorkareaId].images.hasOwnProperty(el._parent.selectId)) {
            $("#move-image-btn").attr('x', moveImagePositions.x).attr('y', moveImagePositions.y);
        }

        if (el.selectType === 'backgrounds' || (el.selectType === 'cell' && el.workData.workareas[el.selectWorkareaId].images.hasOwnProperty(el.selectId))) {
            $("#panel").attr('x', panelsPositions.x).attr('y', panelsPositions.y);
        }
        
        if (el.selectType === 'cell' && !el.workData.workareas[el.selectWorkareaId].images.hasOwnProperty(el.selectId)) {
            $("#panel-cell").attr('x', panelCellPosition.x).attr('y', panelCellPosition.y);
        }
        
        if (el.selectType === 'cell') {
            $('#cell-warning-' + el.selectWorkareaId + '-' + el.selectId).attr('x', centerPositions.x).attr('y', centerPositions.y);
        }
        
        if (el.selectType === 'cell') {
            if (el.cell.alignments.hasOwnProperty('x')) {
                var align = el.cell.alignments.x;
                $("#alignment-x").attr('x1', align.x1).attr('y1', align.y1).attr('x2', align.x2).attr('y2', align.y2).attr('stroke-width', 1);
            } else {
                $("#alignment-x").attr('stroke-width', 0);
            }
            
            if (el.cell.alignments.hasOwnProperty('width')) {
                var align = el.cell.alignments.width;
                $("#alignment-width").attr('x1', align.x1).attr('y1', align.y1).attr('x2', align.x2).attr('y2', align.y2).attr('stroke-width', 1);
            } else {
                $("#alignment-width").attr('stroke-width', 0);
            }
            
            if (el.cell.alignments.hasOwnProperty('y')) {
                var align = el.cell.alignments.y;
                $("#alignment-y").attr('x1', align.x1).attr('y1', align.y1).attr('x2', align.x2).attr('y2', align.y2).attr('stroke-width', 1);
            } else {
                $("#alignment-y").attr('stroke-width', 0);
            }
            
            if (el.cell.alignments.hasOwnProperty('height')) {
                var align = el.cell.alignments.height;
                $("#alignment-height").attr('x1', align.x1).attr('y1', align.y1).attr('x2', align.x2).attr('y2', align.y2).attr('stroke-width', 1);
            } else {
                $("#alignment-height").attr('stroke-width', 0);
            }
        }
    };

    el.show = function (element, workareaId, type, updatePanel) {
        //el.dialog2.hide();
        updatePanel = updatePanel === undefined ? true : updatePanel;
        el._parent.selectType = type;
        el._parent.selectId = element.getAttribute('data-id');
        el._parent.selectWorkareaId = workareaId;
        el._parent.svgRoot = document.getElementById('constructor-hardcover');


        var bg = false;
        switch (type) {
        case 'cell':
            bg = el.svgRoot.getElementById('border-item-' + workareaId + '-' + el._parent.selectId);
            break;
        case 'backgrounds':
            bg = el.svgRoot.getElementById('backgrounds-item-' + workareaId + '-' + el._parent.selectId);
            break;
        case 'decors':
            bg = element;
            break;
        case 'text':
            bg = el.svgRoot.getElementById('text-item-' + workareaId + '-' + el._parent.selectId);
            break;
        }

        calculatePosSelection(bg);
        
        var data = {
            positions: positions,
            panelPositions: panelsPositions,
            panelCellPosition: panelCellPosition,
            rotatePositions: rotatePositions,
            removePositions: removePositions,
            circlePositions: circlePositions,
            layerUpPositions: layerUpPositions,
            layerDownPositions: layerDownPositions,
            moveImagePositions: moveImagePositions,
            copyPositions: copyPositions,
            isExistImage: el.selectType === 'cell' && el.workData.workareas[workareaId].images.hasOwnProperty(el.selectId) ? true : false,
            isExistCell: el.selectType === 'cell' ? true : false,
            isExistText: el.selectType === 'text' ? true : false,
            isExistBackgrounds: el.selectType === 'backgrounds' ? true : false,
            isExistDecor: el.selectType === 'decors' ? true : false
        };

        var output = window.Mustache.render($('#selection-template').html(), data);
        el.workarea.render(output);

        if (updatePanel) {
            el.panel(type);
        }
        
        el._parent.svgRoot = document.getElementById('constructor-hardcover');
        
        switch (type) {
            case 'cell':
                rotateEL = el.svgRoot.getElementById('grid-cell-' + el.selectWorkareaId + '-' + el.selectId);
                initRotateBalloon();
                break;
            case 'decors':
                rotateEL = el.svgRoot.getElementById('decors-item-' + el.selectWorkareaId + '-' + el.selectId);
                initRotateBalloon();
                break;
            case 'text':
                rotateEL = el.svgRoot.getElementById('text-item-' + el.selectWorkareaId + '-' + el.selectId);
                initRotateBalloon();
                break;
        }

        if (type === 'text') {
            el.text.init();
        }
    };

    el.panel = function(type) {
        var selectionPanelData = {
            isExistImage: el.selectType === 'cell' && el.workData.workareas[el.selectWorkareaId].images.hasOwnProperty(el.selectId) && type !=='propertycell',
            isExistCell: el.selectType === 'cell' && type !=='propertycell',
            isExistBackgrounds: el.selectType === 'backgrounds',
            isShowPanel: el.selectType === 'backgrounds' || (el.selectType === 'cell' && el.workData.workareas[el.selectWorkareaId].images.hasOwnProperty(el.selectId)),
            isShowCellPanel: el.selectType === 'cell' && !el.workData.workareas[el.selectWorkareaId].images.hasOwnProperty(el.selectId) && type !=='propertycell',
            isExistText: el.selectType === 'text',
            
        };

        var rotateBalloon = false;

        if (type === 'propertycell') {
            var cell = el.workData.workareas[el.selectWorkareaId].cells[el.selectId];
            selectionPanelData.border = {
                thickness: cell.x - cell.border_x,
                opacity: cell.border_opacity,
                shadow: cell.border_shadow
            };
            selectionPanelData[type] = true;
            rotateBalloon = true;
        }

        var panelHtml = el.templater.render($('#selection-panel-template').html(), selectionPanelData);

        $('.control-panel').addClass('hide');
        $('#selection-panel').html(panelHtml).removeClass('hide');

        if (rotateBalloon) {
            initRotateBalloon();
        }
    };

    el.hide = function () {
        $('.control-panel').addClass('hide');
        $('#main-panel').removeClass('hide');
        el.workarea.render();
        el._parent.svgRoot = document.getElementById('constructor-hardcover');
        hideRotateBalloon();
    };

    el.check = function (event) {
        var selection = document.getElementsByClassName('selection');
        var panel = $(event.target).closest('#selection-panel');
        var colpick = $(".colpick:visible");;

        var colpicVisible = false;
    
        if(colpick.length > 0){
            colpicVisible = true;
            var ev = new Event('mousedown');
            document.querySelector('html').dispatchEvent(ev);
        }

        if (selection.length > 0 && colpicVisible !== true &&  event.target.namespaceURI !== 'http://www.w3.org/2000/svg' && panel.length === 0) {
            el.hide();
        }
    };
    
    $('body').on('touchstart mousedown', el.check);

    $(document).on('click touchend', '.js-select-show', function() {
        el.show(this, $(this).attr('data-workarea'), $(this).attr('data-type'));
        return false; 
    });
};